import StudyBrowserSort from './StudyBrowserSort';
import StudyBrowserSortWithSearch from './StudyBrowserSortWithSearch';

export default StudyBrowserSort;
export { StudyBrowserSort, StudyBrowserSortWithSearch };
